import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PaymentUtilService } from '../payment/services';

@Component({
  selector: 'app-thankyou-page-tip',
  templateUrl: './thankyou-page-tip.component.html',
  styleUrls: ['./thankyou-page-tip.component.scss']
})
export class ThankyouPageTipComponent implements OnInit {

  @Input() config;

  constructor(
    private router: Router,
    private paymentService: PaymentUtilService
  ) { }

  ngOnInit(): void {
    if (this.config?.order || this.config.currency) {
      this.paymentService.paymentCurrency.next(this.config?.order?.iso_currency || this.config.currency);
    }
    this.paymentService.initaiteQr = true;
  }

  redirect() {
    this.router.navigate(['/crowdfunding/fundraisers']);
  }

}
